module.exports = __webpack_public_path__ + "img/Northern Ireland.66440728.svg";